<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="submit" id="gateway_form">
                <kt-row>
                    <kt-col class="col-lg-4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="farsi_name">
                                {{ $t('label.farsi_name') }}
                            </kt-form-label>
                            <kt-form-control
                                id="farsi_name"
                                name="farsi_name"
                                v-model="form_data.farsi_name"
                                class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col class="col-lg-4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="settlement_bank">
                                {{ $t('label.settlement_bank') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="settlement_bank" name="settlement_bank" v-model="form_data.settlement_bank">
                                <option value="ayande" v-text="$t('wallets.bank.ayande')"></option>
                                <option value="saderat" v-text="$t('wallets.bank.saderat')"></option>
                                <option value="keshavarzi" v-text="$t('wallets.bank.keshavarzi')"></option>
                                <option value="saman" v-text="$t('wallets.bank.saman')"></option>
                                <option value="parsian" v-text="$t('wallets.bank.parsian')"></option>
                                <option value="pasargad" v-text="$t('wallets.bank.pasargad')"></option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col class="col-lg-4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="psp">
                                {{ $t('label.psp') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="psp" name="psp" v-model="form_data.psp">
                                <option
                                    v-bind:key="index"
                                    v-for="(psp, index) in psp_list"
                                    v-bind:value="psp.value"
                                    :selected="psp.value"
                                >
                                    {{ psp.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col :class="collectiveTypeStatus ? 'col-lg-4' : 'col-lg-6'" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="status">
                                {{ $t('label.status') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="status" name="status" v-model="form_data.status">
                                <option
                                    v-bind:key="index"
                                    v-for="(status, index) in statuses"
                                    v-bind:value="status.value"
                                    :selected="status.value"
                                >
                                    {{ status.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="collectiveTypeStatus" class="col-lg-4 col-md-6 col-sm-12">
                        <kt-form-group>
                            <kt-form-label for="collective_type">
                                {{ $t('label.collective_type') }}
                            </kt-form-label>

                            <kt-form-select size="4" id="collective_type" name="collective_type" v-model="form_data.collective_type" >
                                <option
                                    v-for="(item, index) in collectiveTypes"
                                    v-bind:key="index"
                                    v-bind:value="item.value"
                                    :selected="item.value"
                                >
                                    {{ item.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col  :class="collectiveTypeStatus ? 'col-lg-4' : 'col-lg-6'" md="12" sm="12">
                        <kt-form-group>
                            <kt-form-label for="website_address">
                                {{ $t('label.website_address') }}
                            </kt-form-label>
                            <kt-form-control
                                id="website_address"
                                name="website_address"
                                v-model="form_data.website_address"
                                class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <novin
                    v-if="form_data.psp == 'novin'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></novin>
                <mellat
                    v-if="form_data.psp == 'mellat'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></mellat>
                <parsian
                    v-if="form_data.psp == 'parsian'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></parsian>
                <pasargad
                    v-if="form_data.psp == 'pasargad'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></pasargad>
                <saman
                    v-if="form_data.psp == 'saman'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></saman>
                <sepehr
                    v-if="form_data.psp == 'sepehr'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></sepehr>
                <asan-pardakht
                    v-if="form_data.psp == 'asanpardakht'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></asan-pardakht>
                <irankish
                    v-if="form_data.psp == 'irankish'"
                    :form_data="form_data"
                    :port_config="form_data.port_config"
                ></irankish>
                <kt-form-action class="mt-4" id="categories">
                    <kt-form-group >
                        <kt-form-label for="category_ids">
                            {{ $t('label.categories') }}
                        </kt-form-label>
                        <select
                            v-if="show_categories_form"
                            id="category_ids"
                            name="category_ids"
                            class="form-control kt-selectpicker"
                            v-model="form_data.shop_category_ids"
                            multiple
                        >
                            <option
                                v-bind:key="index"
                                v-for="(category, index) in categories_for_select"
                                :selected="isSelectedCategory(category.id)"
                                :value="category.id"
                            >
                                {{ category.title }}
                            </option>
                        </select>
                    </kt-form-group>
                </kt-form-action>
                <div class="row">
                    <kt-col lg="4" md="8" sm="12" v-if="form_data.psp == 'sepehr'" class="col-lg-4 col-md-8 col-sm-12">
                        <div style="padding-top: 25px">
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="avoid_showing_supported_acceptor_title"
                                    name="avoid_showing_supported_acceptor_title"
                                    v-model="form_data.avoid_showing_supported_acceptor_title"
                                >
                                <label class="custom-control-label"
                                       for="avoid_showing_supported_acceptor_title">
                                    {{ $t('label.avoid_showing_supported_acceptor_title') }}
                                </label>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="3" md="8" sm="12" v-if="['sepehr', 'mellat', 'asanpardakht','irankish'].includes(form_data.psp)" class="col-lg-2 col-md-8 col-sm-12">
                        <div style="padding-top: 25px">
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="change_gateway_name"
                                    name="change_gateway_name"
                                    v-model="form_data.change_gateway_name"
                                    @change="changeGatewayMethod('change_gateway_name')"
                                >
                                <label class="custom-control-label"
                                       for="change_gateway_name">
                                    {{ $t('label.display_recipient_domain_on_payment_page') }}
                                </label>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="3" md="8" sm="12"  v-if="['sepehr', 'mellat', 'asanpardakht','irankish'].includes(form_data.psp)" class="col-lg-2 col-md-8 col-sm-12">
                        <div style="padding-top: 25px">
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="send_shop_domain"
                                    name="send_shop_domain"
                                    v-model="form_data.send_shop_domain"
                                    @change="changeGatewayMethod('send_shop_domain')"
                                >
                                <label class="custom-control-label"
                                       for="send_shop_domain">
                                    {{ $t('label.send_shop_domain') }}
                                </label>
                            </div>
                        </div>
                    </kt-col>

                    <kt-col lg="3" md="8" sm="12"  class="col-lg-3 col-md-8 col-sm-12">
                        <div style="padding-top: 25px">
                            <div class="custom-control custom-checkbox">
                                <input
                                    type="checkbox"
                                    class="custom-control-input"
                                    id="avoid_using_for_switch"
                                    name="avoid_using_for_switch"
                                    v-model="form_data.avoid_using_for_switch"
                                >
                                <label class="custom-control-label"
                                       for="avoid_using_for_switch">
                                    {{ $t('label.avoid_using_for_switch') }}
                                </label>
                            </div>
                        </div>
                    </kt-col>
                    <kt-col lg="3" md="8" sm="12" class="col-lg-3 col-md-4 col-sm-12" style="display: inline-flex;padding-top: 25px">
                        {{ $t('allotment.allotment_status') + ' : &nbsp;&nbsp;'+' ' }}
                        <div class="custom-control custom-checkbox" id="collective_status-div">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="multiplex_status"
                                name="multiplex_status"
                                @change="changeLabel"
                                v-model="form_data.multiplex_status"
                            >

                            <label class="custom-control-label" id="multiplex_status_label" for="multiplex_status">

                            </label>
                        </div>
                    </kt-col>
                </div>
                <kt-form-action v-show="form_data.multiplex_status" class="mt-4">
                    <kt-panel-body id="sheba_number_repeater">
                        <div v-if="has_failed_to_sync_sheba_numbers" class="bg-danger text-white pt-2 rounded mb-4">
                            <div class="mb-2 px-4">{{ $t('validation.failed_to_sync_sheba_numbers_error') }}</div>
                            <ul>
                                <li v-for="(sheba_number, index) in failed_to_sync_sheba_numbers" :key="index"
                                    v-text="sheba_number"></li>
                            </ul>
                        </div>
                        <kt-form-section data-repeater-list="sheba_numbers">
                            <kt-row hor data-repeater-item
                                    v-for="(sheba_number,index) in shebas"
                                    v-bind:key="index">

                                <kt-col lg="6" md="6" sm="12" xs="12">
                                    <kt-form-group>
                                        <kt-form-label>
                                            {{ $t('panel.profile.bankAccount.shebaNumber') }}
                                        </kt-form-label>
                                        <kt-input-group class="" id="sheba_number">
                                            <kt-form-control onkeyup="checkSheba(event)" dir="ltr"
                                                             name="inner-text-input-sheba"
                                                             aria-describedby="national_code-error"
                                                             :data-id="index"
                                                             :value="sheba_number.number"></kt-form-control>
                                            <kt-input-group-append>
                                                <kt-input-group-text>IR</kt-input-group-text>
                                            </kt-input-group-append>
                                        </kt-input-group>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="3" md="3" sm="12" xs="12">
                                    <kt-form-group>
                                        <kt-form-label class="ml-2">
                                            {{ $t('allotment.percent') }}
                                        </kt-form-label>
                                        <kt-input-group class="" id="por">
                                            <kt-form-control
                                                :value="sheba_number.percent"
                                                :data-id="index"
                                                name="percent"
                                                type="number"
                                                class="form-control">
                                            </kt-form-control>
                                        </kt-input-group>
                                    </kt-form-group>
                                </kt-col>

                                <kt-col style="margin-top: 26px" lg="2" md="2" sm="12" xs="12">
                                    <kt-form-group>
                                        <a @click.prevent="deleteItem(index)" data-repeater-delete
                                           class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                                            <i class="la la-trash-o"></i>
                                            {{ $t('btn.delete') }}
                                        </a>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                        <kt-form-group hor>
                            <a data-repeater-create class="btn btn-bold btn-sm btn-label-brand">
                                <i class="la la-plus"></i> {{ $t('btn.add') }}
                            </a>
                        </kt-form-group>
                    </kt-panel-body>
                </kt-form-action>
                <kt-form-action class="mt-4">
                    <button
                        id="submit_btn"
                        class="btn btn-md btn-success btn-wide"
                        @click.prevent="preUpdate"
                    >
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>

import {i18n} from '@/plugins/i18n'
import {dedicatedStatusStr, dedicatedStatus, dedicatedCollectiveType, dedicatedCollectiveTypeStr} from '@/constants/dedicatedStatus'
import {novin, parsian, pasargad, saman, mellat, sepehr, asanPardakht,irankish} from './psp_data_forms'
import $ from "jquery";
import IranSheba from "iran-sheba";
import Inputmask from "inputmask";
import toastr from "toastr";
import axios from "axios";
import {ApiUrl, dedicatedService} from "../../../common/api.service";

export default {
    props: {
        submit: {
            default: () => {
                return {}
            },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        },
        psp: {
            default() {
                return {}
            },
            type: Array
        },
        port_config: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data() {
        return {
            shebas: {
                'percent': '',
                'number': ''
            },
            has_failed_to_sync_sheba_numbers: false,
            failed_to_sync_sheba_numbers: null,
            collective: {},
            percent: 0,
            psp_list: [
                {
                    name: i18n.t('psp_list.novin'),
                    value: 'novin'
                },
                {
                    name: i18n.t('psp_list.mellat'),
                    value: 'mellat'
                },
                {
                    name: i18n.t('psp_list.pasargad'),
                    value: 'pasargad'
                },
                {
                    name: i18n.t('psp_list.parsian'),
                    value: 'parsian'
                },
                {
                    name: i18n.t('psp_list.saman'),
                    value: 'saman'
                },
                {
                    name: i18n.t('psp_list.sepehr'),
                    value: 'sepehr'
                },
                {
                    name: i18n.t('psp_list.asan-pardakht'),
                    value: 'asanpardakht'
                },
                {
                    name: i18n.t('psp_list.irankish'),
                    value: 'irankish'
                },
            ],
            statuses: [
                {
                    name: dedicatedStatusStr.ACTIVE,
                    value: dedicatedStatus.ACTIVE
                },
                {
                    name: dedicatedStatusStr.PENDING,
                    value: dedicatedStatus.PENDING
                },
                {
                    name: dedicatedStatusStr.REJECTED,
                    value: dedicatedStatus.REJECTED
                },
                {
                    name: dedicatedStatusStr.BLOCKED,
                    value: dedicatedStatus.BLOCKED
                },
                {
                    name: dedicatedStatusStr.SEND_TO_PSP,
                    value: dedicatedStatus.SEND_TO_PSP
                },
                {
                    name: dedicatedStatusStr.REJECTED_BY_PSP,
                    value: dedicatedStatus.REJECTED_BY_PSP
                },
            ],
            collectiveTypes: [
                {
                    name: dedicatedCollectiveTypeStr.DIRECET_TO_PSP,
                    value: dedicatedCollectiveType.DIRECET_TO_PSP
                },
                {
                    name: dedicatedCollectiveTypeStr.USE_PAYMENT_HELPER,
                    value: dedicatedCollectiveType.USE_PAYMENT_HELPER
                }
            ],
            categories_for_select: {},
            show_categories_form: false,
        }
    },
    components: {
        'novin': novin,
        'parsian': parsian,
        'pasargad': pasargad,
        'saman': saman,
        'mellat': mellat,
        'sepehr': sepehr,
        'asan-pardakht': asanPardakht,
        'irankish': irankish
    },
    mounted() {
        this.changeLabel()
        this.initial()
        if (this.form_data.sheba_numbers){
            this.shebas=this.form_data.sheba_numbers
        }
        this.getCategoriesData()
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
        collectiveTypeStatus() {
            let x = false
            // this.form_data.collective_type = 0;
            for (let $i = 0; $i < this.psp.length; $i++) {
                if (this.psp[$i] == this.form_data.psp) x = true
            }
            return x;
        }
    },
    methods: {
        changeGatewayMethod(checkboxName) {
            if (checkboxName === 'change_gateway_name') {
                this.form_data.send_shop_domain = false;
            } else if (checkboxName === 'send_shop_domain') {
                this.form_data.change_gateway_name = false;
            }
        },
        deleteItem(index) {
            this.shebas[index].percent='';
            this.shebas[index].number='';
        },
        changeLabel() {

            let label = $('#multiplex_status_label')
            let checkbox = $('#multiplex_status')

            if (checkbox.is(':checked')) {
                label.html(i18n.t('label.active'))
            } else {
                label.html(i18n.t('label.inactive'))
            }
        },
        addValidationError(item) {
            this.rmValidationError(item)
            this.deleteBankName(item)
            new Promise((resolve, reject) => {
                let elem = document.getElementById($(item).prop('name') + '-error')
                if (elem) {
                    elem.parentNode.removeChild(elem)
                }

                resolve()
            }).then(() => {
                let error_el = '<div id="' + $(item).prop('name') + '-error" class="d-block error invalid-feedback pl-3">' + this.$t('validation.invalid_sheba_number') + '</div>'
                $(item).closest('.input-group').append(error_el)
            })
        },
        rmValidationError(item) {
            let elem = document.getElementById($(item).prop('name') + '-error')
            if (elem) {
                elem.parentNode.removeChild(elem)
            }
        },
        initial() {
            $('#sheba_number_repeater').repeater({
                initEmpty: false,
                isFirstItemUndeletable: true,
                show: function () {
                    $(this).slideDown();
                    Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
                },

                defaultValues: {
                    'text-input': null
                },

                hide: function (deleteElement) {
                    $(this).slideUp(deleteElement);
                }
            });

            //initial inputs
            Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('#sheba_number input'))
        },
        deleteBankName(item) {
            let elem = document.getElementById($(item).prop('name') + '-icon')
            if (elem) {
                elem.parentNode.removeChild(elem)
            }
        },
        preUpdate(e) {
            let is_valid = true;
            let number = [];
            let percent = [];
            if (!this.form_data.multiplex_status) {
                this.form_data.sheba_numbers = [];
                this.submit()
                return
            } else {
                let submit_promise = new Promise((resolve, reject) => {
                    $('#sheba_number input').map((index, item) => {
                        const value = $(item).prop('value')
                        if (value) {
                            const sheba = 'IR' + value.split('-').join('')
                            if (!IranSheba.isValid(sheba)) {
                                this.addValidationError(item)
                                is_valid = false
                            } else {
                                this.rmValidationError(item)
                                number.push({
                                    id: index,
                                    value: value
                                })
                            }
                        } else {
                            this.addValidationError(item)
                        }
                    })
                    $('#por input').map((index, item) => {
                        const value = $(item).prop('value')
                        if (value) {
                            percent.push({
                                id: index,
                                value: value
                            })
                        }
                    })
                    resolve(percent, number)
                })
                if (is_valid) {
                    submit_promise.then(sheba_numbers => {
                        this.form_data.sheba_numbers = [];
                        let count_percent = 0;
                        for (let i = 0; i < number.length; i++) {
                            if (number[i].value && percent[i].value) {
                                count_percent += parseInt(percent[i].value)
                                this.form_data.sheba_numbers[i] =
                                    {
                                        'number': number[i].value,
                                        'percent': percent[i].value
                                    }
                            }
                        }
                        if (count_percent <= 100) {
                            this.submit()
                            return
                        } else this.toastr.error(i18n.t('allotment.allotment_percent_limitation'));
                        return
                    });
                }
            }
        },
        getCategoriesData(){
            dedicatedService.fetchCategoriesForSelect(true).then(res => {
                this.categories_for_select = res.data.data
                dedicatedService.fetchShopCategories(this.$route.params.hashid).then(res => {
                    this.form_data.shop_category_ids = res.data.data
                    this.show_categories_form = true
                }).finally(()=>{
                    this.runSelectPicker()
                })
            })

        },
        isSelectedCategory(hashid) {
            return Object.values(this.form_data.shop_category_ids).includes(hashid)
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
    }
}
</script>

<style>
.color-novin {
    color: #683f84;
}

.color-mellat {
    color: #ed1b2f;
}

.color-saman {
    color: #07abea;
}

.color-parsian {
    color: #9c0f1e;
}

.color-pasargad {
    color: #f58500;
}
</style>